import styled from 'styled-components';

import {
  IncentiveEvaluationMessage,
  IncentiveEvaluationMessages,
} from 'components/incentive-evaluation-messages/incentive-evaluation-messages';

import { MobileAreaOptions } from './content/types';
import Details from './details';

export const SectionContainer = styled.div<{
  isCatering: boolean;
  hasHorizontalPadding?: boolean;
}>``;

export const EnsureBottomPadding = styled.div`
  padding-bottom: env(safe-area-inset-bottom);
`;

export const HeadingSuperText: React.FC = () => null;

export const Heading: React.FC = () => null;

export const OfferErrorFeedback = styled.span`
  display: block;
  font-size: 1rem;
`;

export const CartContentWrapper = styled.div<{ insetTop: number }>`
  margin: ${props => props.insetTop}px auto 0;
  width: 100vw;
`;

export const StyledIncentiveEvaluationMessages = styled(IncentiveEvaluationMessages)`
  border: solid 1px ${Styles.color.red};
  padding: 1rem;
  align-items: center;
`;

export const StyledIncentiveEvaluationMessage = styled(IncentiveEvaluationMessage)`
  border: solid 1px ${Styles.color.red};
  padding: 1rem;
`;

export const PaymentArea = styled.div`
  grid-area: ${MobileAreaOptions.PAYMENT};
`;

export const CartWrap = styled.div`
  grid-area: cart;
`;

export const StyledDetails = styled(Details)`
  grid-area: details;
`;

export const AddOnContainer = styled.div`
  grid-area: ${MobileAreaOptions.ADDONS};
`;
